
<template>
  <div class="select-member">
      <div class="selected-member" v-for="(obj, index) in selectedUsers" :key="index" >
        <Poptip  trigger="hover" width="240">
      
          <Avatar :icon="obj.name ? '' : 'person'" :src="obj.headPic">{{obj.name ? obj.name.substr(0, 2) : ''}}</Avatar>
          <div slot="title">
            <div class="selected-member-detail g-flex">
              <Avatar :icon="obj.name ? '' : 'person'" :src="obj.headPic" style="text-aline:center">{{obj.name ? obj.name.substr(0, 2) : ''}}</Avatar>
              <div class="g-flex-1">
               <h2>{{obj.name}}</h2>
               <!--  <p>{{obj.positionName}}</p> -->
              </div>
            </div>
          </div>
          <!-- <div slot="content" v-if="isEdit && canExit">
            <button  type="button" class="exit-member-btn" @click="exitMember(index)">{{exitTxt}}</button>
          </div> -->
        </Poptip>
              </div>
              
            </div>
         
</template>

<script>
import clickoutside from "../../directives/clickoutside";
export default {
  name: "common-member-ii",
  directives: { clickoutside },
  props: {
    users: {
      type:Array,
    },
  },
  data() {
    return {
      selectedUsers: this.users || [],
      allUsers: [],
      result: [],
    };
  },
  computed: {
    _selectedUsers() {
      return this.users || [];
    },
  },
  watch: {
    users: {
      // immediate: true,
      handler(data) {
        this.selectedUsers = data;
      },
    },
  },
mounted(){
},
  methods: {
    
  },
};
</script>

<style scoped lang="less">
/deep/.ivu-avatar-string{
position: none !important;
}
 /deep/ .ivu-avatar {
      margin-right: 12px;
      width: 25px !important;
      height: 25px !important;
      border-radius: 25px;
      line-height: 25px;
      >span{
        text-align: center !important;
        // left: calc(30% - 0px) !important;
        position: none !important;
      }
    }
   /deep/ .ivu-avatar>*{
  line-height: 25px;
    }
.no-head-img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  text-align: center;
  line-height: 30px;
  background: #CCCCCC;
  color: white;
  font-size: 10px;
  font-weight: bolder;
}
.selected-member {
  display: inline-block;
  // line-height: 48px;
  vertical-align: top;
  // margin-right: 10px;

  .selected-member-detail {
    /deep/.ivu-avatar-string{
position: inherit !important;
left: 0 !important;
}
   /deep/ .ivu-avatar {
      margin-right: 12px;
      width: 25px !important;
      height: 25px !important;
      border-radius: 25px;
      line-height: 25px;
    }
    .ivu-avatar>*{
  line-height: 25px;
    }
    h2 {
      color: #343a40;
      font-size: 18px;
      font-weight: normal;
      font-family: Abel;
    }
    p {
      color: #343a40;
      font-size: 10px;
      font-family: Abel;
    }
  }
  .exit-member-btn {
    display: block;
    width: 100%;
    height: 32px;
    background-color: #f1f3f5;
    border: 1px solid #e9ecef;
    border-radius: 0;
    color: #868e96;
    font-size: 12px;
  }
}
.select-member {
  position: relative;
  display: inline-block;
  cursor: pointer;
  vertical-align: middle;
  > div {
    display: inline-block;
    /*letter-spacing: -1px;*/
  }
}
.member-add {
  line-height: 53px;
  vertical-align: middle;
}
.opened {
  opacity: 1 !important;
  z-index: 100 !important;
}

// memberSelection
.member-search {
  padding: 16px;
}
.result {
  height: 48px * 3;
  overflow: auto;
}
.often {
  ul {
    li {
      width: 50%;
    }
  }
  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 96px;
    p {
      font-family: PingFangSC;
      font-size: 12px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: left;
      color: #868e96;
    }
  }
}
h4 {
  font-family: PingFangSC;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #868e96;
  padding: 0 16px;
}
//   .member-selection-pop {
//     position: absolute;
//     box-shadow: 0 2px 4px 0 rgba(134, 142, 150, 0.6);
//     border: solid 1px #e9ecef;
//     background-color: #fff;
//     z-index: -1;
//     /*padding: 16px;*/
//     top: 100%;
//     left: -7px;
//     transition: all .2s ease;
//     opacity: 0;
//     padding-bottom: 16px;
//     .member-name-ipt {
//       width: 320px;
//     }
//     ul {
//       li {
//         padding: 0 24px;
//         height: 48px;
//         line-height: 48px;
//         cursor: default;
//         &:hover {
//           background-color: #f1f3f5;
//         }
//         .ivu-avatar {
//           margin-right: 16px;
//         }
//       }
//     }
//   }
</style>
